'use strict';
const mmWidgets = require('./mm-widgets'),
	ACTIVITY = {
		saving: 'Saving sharing information, please wait...',
		loading: 'Loading sharing information, please wait...'
	};
require('./section-handler-widget');
require('./show-error');
require('./show-progress-message');
require('./gold-map-sub-team-sharing-list-widget');
require('./gold-map-sharing-list-widget');
require('./gold-map-direct-share-widget');
require('./crowdlink-sharing-widget');

mmWidgets.fn.goldMapSharingWidget = function (mapSharingModel) {
	if (!mapSharingModel) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const element = this.sectionHandlerWidget().goldMapSharingListWidget(mapSharingModel).goldMapDirectShareWidget(mapSharingModel).crowdlinkSharingWidget(mapSharingModel),
			onError = (error) => {
				element.showError(error);
			},
			onContext = (context) => {
				if (context.activity) {
					element.showProgressMessage(ACTIVITY[context.activity] || context.activity);
				}
			},
			subteamSharingList = element.find('[data-mm-role~="subteam-sharing-list"]').goldMapSubteamSharingListWidget(mapSharingModel);

		element.on('show', () => {

			element.showProgressMessage(ACTIVITY.loading);
			element.find('tabbedsection').trigger('resetdefaulttab');
			subteamSharingList.trigger('enable');
			mapSharingModel.addEventListener('context', onContext);
			mapSharingModel.addEventListener('error', onError);
			mapSharingModel.load();
			mapSharingModel.showGoldSharing();
		});
		element.on('hide', () => {
			subteamSharingList.trigger('disable');
			mapSharingModel.removeEventListener('context', onContext);
			mapSharingModel.removeEventListener('error', onError);
		});
	});
};
